<template>
    <div>

    </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        methods: {},
        mounted(){

        }
    }
</script>


// WEBPACK FOOTER //
// RebateStat.vue?3b3cfe10